import React, { ExoticComponent, Fragment } from "react";

interface MultilineTextProps {
  children: string;
  wrapLinesWith?: ExoticComponent<{ children: string }>;
  wrapperProps?: any;
}

const MultilineText = ({
  children,
  wrapLinesWith: Wrapper = Fragment,
  wrapperProps,
}: MultilineTextProps) => {
  return (
    <Fragment>
      {children.split("\n").map((item, key) => (
        <Fragment key={key}>
          <Wrapper {...wrapperProps}>{item}</Wrapper>
          <br />
        </Fragment>
      ))}
    </Fragment>
  );
};

export default MultilineText;
